import RMOPendingAppointmentComponent from './RMOPendingAppointmentComponent';
export default RMOPendingAppointmentComponent;
